import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'sanitizeHtml' })
export class SanitizeHtmlPipe implements PipeTransform {
    private domSanitizer: DomSanitizer = inject(DomSanitizer);

    private decodeHtml(value: string): string {
        return (
            new DOMParser().parseFromString(value, 'text/html').documentElement
                .textContent || value
        );
    }

    transform(value: string | undefined): SafeHtml {
        if (!value) return '';

        return this.domSanitizer.bypassSecurityTrustHtml(this.decodeHtml(value));
    }
}
